import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    async function refresh() {
        if (!getToken()) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setToken(null);
            setUser(null);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        refresh();
    }, []);

    async function loginWith(email, password) {
        const { data } = await api.post("/auth/login", { email, password });
        setToken(data.access_token);
        setUser(data.user);
        return data.user;
    }

    async function registerAgency(payload) {
        const { data } = await api.post("/auth/register/agency", payload);
        setToken(data.access_token);
        setUser(data.user);
        return data.user;
    }

    async function registerCaregiver(payload) {
        const { data } = await api.post("/auth/register/caregiver", payload);
        setToken(data.access_token);
        setUser(data.user);
        return data.user;
    }

    async function registerFamily(payload) {
        const { data } = await api.post("/auth/register/family", payload);
        setToken(data.access_token);
        setUser(data.user);
        return data.user;
    }

    function logout() {
        setToken(null);
        setUser(null);
    }

    return (
        <AuthContext.Provider
            value={{ user, loading, refresh, loginWith, registerAgency, registerCaregiver, registerFamily, logout }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
